import controller from './categories-filter.controller';
import templateBase from './templates/categories-filter-base.view.html';

let CategoriesFilterComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        isProcedure:'<',
        sisters:"<",
        company:"<",
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default CategoriesFilterComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/categories-filter/categories-filter.component.js